import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class SizeGuide extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;
    @Prop({default: window.scrollY}) scrollPosition!: number;

    @Ref({required: false}) trigger!: HTMLElement;
    @Ref({required: false}) guide!: HTMLElement;
    @Ref({required: false}) close!: HTMLElement;

    init() {

        // Give initial value for scrollPosition
        this.scrollPosition = window.scrollY;

        // Init trigger click event listener
        if (this.trigger) {
            this.$listen(this.trigger, 'click', () => {

                // Add active class
                this.guide.classList.add('size-guide__pop-up--active');

                // Disable body scrolling
                this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
            });
        }

        // Init close click event listener
        if (this.close) {
            this.$listen(this.close, 'click', () => {

                // Remove active class
                this.guide.classList.remove('size-guide__pop-up--active');

                // Enable body scrolling
                this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
            });
        }
    }
}
